module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAhElEQVQ4y9XMoQ0DIQBGYSxbdAVmqEQzAwJJGIAFcMXWsAJjwAQIPGwA5O8CvUvvFH3Jsx8he/R449b7APhSaw0hBMQYcdQpUEqBMQbOOay1rgMpJTDGIITAnPMaUGsF5xyEEFBKobXGGON3IOcMay2klFBKwXuP3vsxQF5P3Hoj4K/7AJSzkcuCLhYjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LS.png
// module id = 1195
// module chunks = 0